/**
 * Import Dependency
 */
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

/**
 * Import Component
 */
import PageTitle from '../../components/PageTitle'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {

  }
}
const mapDispatchToProps = (dispatch) => {
  return {

  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageTitle))



// WEBPACK FOOTER //
// ./src/containers/components/PageTitle.js